export default __webpack_public_path__ + "static/media/LK.53b193b8.svg";